export default class OfferActivatePriceDialog {
  constructor($scope, OfferService) {
    $scope.$on('open_activate_price_dialog', function(event, args) {
      $scope.offer_id = args.offer_id;
      $scope.supplier_id = args.supplier_id;
      $scope.buyer_id = args.buyer_id;
      $scope.country_id = args.country_id;
      $scope.open_dialog();
    });

    $scope.open_dialog = function() {
      $scope.activate_loading = true;
      OfferService.get_prices_for_activation($scope.offer_id, $scope.supplier_id, $scope.buyer_id, $scope.country_id).then(function(data) {
        $scope.uspp_prices = data.uspp_prices;
        $scope.uspc_prices = data.uspc_prices;
        $scope.activate_loading = false;
      });
      window.openFancyboxDialog('div#activate_price_dialog');
    };

    $scope.update_uspp_activation = function(price) {
      price.updating = true;
      OfferService.set_uspp_activation(price.id, !price.auto_activation).then(function(response) {
        if (response.data.success) {
          price.auto_activation = !price.auto_activation;
          price.updating = false;
        }
      });
    };

    $scope.update_uspc_activation = function(price) {
      price.updating = true;
      OfferService.set_uspc_activation(price.id, !price.auto_activation).then(function(response) {
        if (response.data.success) {
          price.auto_activation = !price.auto_activation;
          price.updating = false;
        }
      });
    };

    $scope.init = function() {
      $scope.uspp_prices = [];
      $scope.uspc_prices = [];
    };

    $scope.init();
  }
}

OfferActivatePriceDialog.$inject = ['$scope', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-activate-price-dialog.ctrl.js